import {AppName, AppPlantSelectOption, PlantId} from '@hconnect/common/hproduce/types'
import {makeStyles, MenuItem, MenuList, Box} from '@material-ui/core'
import {Check} from '@material-ui/icons'
import classNames from 'classnames'
import React from 'react'

import {AppLogo} from '../../common/assets/HProduceApps'
import Divider from '../Molecules/Divider'

export type ProductSelectProps = {
  activeAppName?: AppName | 'HProduce' | 'HConnect'
  activePlantId?: PlantId
  'data-test-id'?: string
  options: AppPlantSelectOption[]
}

const useProductStyles = makeStyles((theme) => ({
  item: {
    color: theme.palette.text.primary,
    padding: theme.spacing(2, 3),
    lineHeight: 1.5,
    '& svg': {
      marginRight: theme.spacing(1)
    },
    '&:hover': {
      background: 'rgba(1, 106, 212, 0.04)'
    }
  },
  link: {
    textDecoration: 'none'
  },
  active: {
    '& $item': {
      '&:hover': {
        background: 'rgba(1, 106, 212, 0.12)'
      }
    }
  },
  divider: {
    margin: theme.spacing(0, 2)
  }
}))

export const ProductSelect: React.FC<ProductSelectProps> = ({
  options,
  activeAppName,
  activePlantId,
  'data-test-id': dataTestId
}) => {
  const classes = useProductStyles()

  return (
    <MenuList disablePadding data-test-id={dataTestId}>
      {options.map((option, i) => {
        const {appName} = option
        const isActive = option.plantId === activePlantId && appName === activeAppName

        return (
          <a
            key={option.appName}
            href={option.url}
            className={classNames(classes.link, isActive && classes.active)}
            data-test-id={dataTestId ? `${appName}-${dataTestId}` : appName}
          >
            <MenuItem className={classes.item}>
              <AppLogo name={appName} size={16} />
              <Box component={'span'} flex={1}>
                {appName}
              </Box>
              {activeAppName === appName && <Check />}
            </MenuItem>
            {i < options.length - 1 && (
              <Divider orientation="horizontal" color="soft" className={classes.divider} />
            )}
          </a>
        )
      })}
    </MenuList>
  )
}
